import { ServiceResponse } from "../ServiceResponse";

export class ForgotPasswordResponse extends ServiceResponse {
  public sendEmailSuccess: boolean = false;
}
